<template>
    <div>
        <div>
            <div style="display: flex;justify-content: flex-start">
                <el-date-picker
                        v-model="searchValue.generateCodeDate"
                        type="date"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd">
                </el-date-picker>
                <el-input placeholder="生成码编号" prefix-icon="el-icon-search"
                          clearable
                          @clear="initGenerates"
                          style="width: 150px;margin-left: 10px" v-model="searchValue.generateCodeId"
                          @keydown.enter.native="initGenerates"></el-input>
                <el-input placeholder="附加信息" prefix-icon="el-icon-search"
                          clearable
                          @clear="initGenerates"
                          style="width: 150px;margin-right: 10px;margin-left: 10px" v-model="searchValue.generateCodeMessage"
                          @keydown.enter.native="initGenerates"></el-input>
                <el-button icon="el-icon-search" type="primary" @click="initGenerates">
                    搜索
                </el-button>
            </div>
            <div style="display: flex;justify-content: flex-start; margin-top: 10px">
                <el-button type="primary" icon="el-icon-plus" @click="showQRGenerateView">
                    生成码
                </el-button>
                <el-button icon="el-icon-s-grid" @click="showCodeBatchView">
                    码批次管理
                </el-button>
                <el-button icon="el-icon-s-unfold" @click="goProductUnite">
                    产品赋码
                </el-button>
            </div>
        </div>
        <div style="margin-top: 10px">
            <el-table
                    :data="generates"
                    stripe
                    border
                    width="100%"
                    v-loading="loading"
                    element-loading-text="正在加载..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.5)"
                    style="width: 100%">
<!--                <el-table-column-->
<!--                        type="selection"-->
<!--                        min-width="3%">-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="generateCodeId"
                        align="center"
                        label="生码编号"
                        min-width="7%">
                </el-table-column>
                <el-table-column
                        prop="generateCodeCodeNumber"
                        label="码量"
                        align="center"
                        min-width="6%">
<!--                    <template slot-scope="scope"> {{scope.row.generateCodeCodeNumber}} </template>-->
                </el-table-column>
                <el-table-column
                        prop="generateCodeEnableNumber,generateCodeStopNumber"
                        label="启用/停用量"
                        align="center"
                        min-width="13%">
                    <template slot-scope="scope">
                        <span style="color: #008000">
                            {{scope.row.generateCodeEnableNumber}}
                        </span>
                        /
                        <span style="color: #FF0000">
                            {{scope.row.generateCodeStopNumber}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="generateCodeStatus"
                        label="状态"
                        align="center"
                        min-width="6%">
                    <template slot-scope="scope">
                        <div v-if=" '2' == scope.row.generateCodeStatus ">
                            <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    content="生码失败，请重新生成或联系管理员">
                                <i class="el-icon-warning" style="color: #ff0000" slot="reference"></i>
                            </el-popover>
                        </div>
                        <div v-if=" '1' == scope.row.generateCodeStatus ">
                            <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    content="生码成功，请下载">
                                <i class="el-icon-success" style="color: #67c23A" slot="reference"></i>
                            </el-popover>
                        </div>
                        <div v-if=" '0' == scope.row.generateCodeStatus ">
                            <el-popover
                                    placement="top-start"
                                    width="200"
                                    trigger="hover"
                                    content="生码中，请等待">
                                <i class="el-icon-success" style="color: #606266" slot="reference"></i>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="generateCodeProductNumber"
                        min-width="8%"
                        align="center"
                        label="产品赋码">
                    <template slot-scope="scope">
                        <span style="color: #0000FF">
                            {{scope.row.generateCodeProductNumber}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="generateCodeActivityNumber"
                        min-width="8%"
                        align="center"
                        label="活动码量">
                    <template slot-scope="scope">
                        <span style="color: #0000FF">
                            {{scope.row.generateCodeActivityNumber}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="generateCodeCheckcode"
                        min-width="8%"
                        align="center"
                        label="查验码">
                </el-table-column>
                <el-table-column
                        prop="generateCodeMessage"
                        min-width="15%"
                        align="center"
                        label="附加信息">
                </el-table-column>
                <el-table-column
                        prop="generateCodeUpdatetime"
                        :formatter="formatGenerateDate"
                        min-width="13%"
                        align="center"
                        label="时间">
                </el-table-column>
                <el-table-column
                        min-width="10%"
                        align="center"
                        label="操作">
                    <template slot-scope="scope">
                        <div v-if=" '2' == scope.row.generateCodeStatus ">
                            <el-button slot="reference" style="padding: 3px" @click="regenerate(scope.row)" size="mini" type="primary">重新生成</el-button>
                        </div>
                        <el-button slot="reference" :disabled="scope.row.generateCodeStatus!='1'" style="padding: 3px" @click="downloadFile(scope.row.generateCodeId)" size="mini" type="success">下载</el-button>
                        <el-button @click="deleteGenerateCode(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;">
                <el-pagination
                        background
                        @current-change="currentChange"
                        @size-change="sizeChange"
                        layout="sizes, prev, pager, next, jumper, ->, total, slot"
                        :total="total">
                </el-pagination>
            </div>
            <div style="padding: 25px">
                <div class="templateBottom">
                    <p style="height: 8px">说明:</p>
                    <p style="height: 5px">1.</p>
                    <p style="height: 5px">2.</p>
                    <p style="height: 5px">3.</p>
                </div>
            </div>
        </div>
        <el-dialog
                :title="title"
                :visible.sync="dialogGenerateVisible"
                width="80%">
            <div>
                <el-form :model="generate" :rules="rulesGenerate" ref="generateForm">
                    <el-form-item style="display: flex;justify-content: space-between;">
                        <el-form-item label="附加信息:">
                            <el-input style="width: 300px" prefix-icon="el-icon-edit" v-model="generate.generateCodeMessage"
                                      placeholder="请输入信息" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="码页面模板:" prop="scanTemplateId" style="margin-left: 40px;">
                            <el-select v-model="generate.scanTemplateId" clearable placeholder="请选择">
                                <el-option
                                        v-for="item in templateOptions"
                                        :key="item.scanTemplateId"
                                        :label="item.scanTemplateName"
                                        :value="item.scanTemplateId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="生成类型:" prop="generateCodeType" style="display: flex;justify-content: flex-end; margin-left: 40px;">
                            <el-radio-group v-model="generate.generateCodeType" class="templateType">
                                <el-radio label="0" >txt文件</el-radio>
                                <el-radio label="1" >二维码图片</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form-item>
                    <el-table
                            ref="generateTable"
                            :data="codeBatchs"
                            stripe
                            border
                            width="100%"
                            v-loading="loading"
                            element-loading-text="正在加载..."
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                min-width="3%">
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchId"
                                align="center"
                                label="批次号"
                                min-width="10%">
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchPrefix, totalCodeBatchStartNumber,totalCodeBatchEndNumber,codeBatchCodeNumber"
                                label="前缀 | 流水号(码量)"
                                align="center"
                                min-width="30%">
                            <template slot-scope="scope"> {{scope.row.codeBatchPrefix}} | {{scope.row.totalCodeBatchStartNumber}}~{{scope.row.totalCodeBatchStartNumber}}({{scope.row.codeBatchCodeNumber}}) </template>
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchEnableNumber,codeBatchStopNumber"
                                label="启用/停用量"
                                align="center"
                                min-width="15%">
                            <template slot-scope="scope">
                                <span style="color: #008000">
                                    {{scope.row.codeBatchEnableNumber}}
                                </span>
                                /
                                <span style="color: #FF0000">
                                    {{scope.row.codeBatchStopNumber}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchEnable"
                                min-width="10%"
                                align="center"
                                label="批次是否启用">
                            <template slot-scope="scope">
                                <div>
                                    <i class="el-icon-success" :style="{'color': (scope.row.codeBatchEnable=='1'? '#67c23A':'#606266')}" ></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchUpdatetime"
                                :formatter="formatCodeBatchDate"
                                min-width="15%"
                                align="center"
                                label="时间">
                        </el-table-column>
                    </el-table>
                    <div style="display: flex;justify-content: center;">
                        <el-pagination
                                background
                                @current-change="currentUnusedBatchChange"
                                @size-change="sizeUnusedBatchChange"
                                :page-size="sizeBatch"
                                :page-sizes="[5,10,20,30,50,100]"
                                layout="sizes, prev, pager, next, jumper, ->, total, slot"
                                :total="totalBatch">
                        </el-pagination>
                    </div>
                </el-form>
            </div>
            <span slot="footer" style="display: flex;justify-content: center">
                <el-button type="success" @click="doAddGenerate">生 成</el-button>
                <el-button @click="dialogGenerateVisible = false">取 消</el-button>
            </span>
        </el-dialog>
        <el-dialog
                :title="title"
                :visible.sync="dialogCodeBatchVisible"
                width="80%">
            <div>
                <el-form :model="codeBatch" :rules="rulesBatch" ref="codeBatchForm">
                    <el-row :gutter="20" type="flex" justify="center">
                        <el-col :span="6">
                            <el-form-item label="总可用码量:">
                                <b>{{codeBatch.enableCodeNumber}}</b>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="批次前缀:">
                                <el-input style="width: 120px" prefix-icon="el-icon-edit" v-model="codeBatch.codeBatchPrefix"
                                          placeholder="请输入前缀"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="该批次码量:" prop="codeBatchCodeNumber">
                                <el-input style="width: 150px" prefix-icon="el-icon-edit" v-model="codeBatch.codeBatchCodeNumber"
                                          placeholder="请输入码量"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" type="flex" justify="center">
                        <el-col :span="6">
                            <el-form-item label="起始编号:">
                                <el-input-number :min="1" :max="10001" label="起始编号" v-model="codeBatch.codeBatchStartNumber" ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="编号位数:">
                                <el-input-number :min="6" :max="10" label="编号数字部分位数" v-model="codeBatch.codeBatchCodeLength" ></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6" style="display: flex;justify-content: center">
                            <el-form-item>
                                <el-button type="primary" @click="doAddCodeBatch">添加批次</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-table
                            :data="codeBatchs"
                            stripe
                            border
                            width="100%"
                            v-loading="loading"
                            element-loading-text="正在加载..."
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.5)"
                            style="width: 100%">
                        <!--                <el-table-column-->
                        <!--                        type="selection"-->
                        <!--                        min-width="3%">-->
                        <!--                </el-table-column>-->
                        <el-table-column
                                prop="codeBatchId"
                                align="center"
                                label="批次号"
                                min-width="10%">
                        </el-table-column>
                        <el-table-column
                                prop="generateCodeId"
                                align="center"
                                label="生码号"
                                min-width="10%">
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchPrefix, totalCodeBatchStartNumber,totalCodeBatchEndNumber,codeBatchCodeNumber"
                                label="前缀 | 流水号(码量)"
                                align="center"
                                min-width="25%">
                            <template slot-scope="scope"> {{scope.row.codeBatchPrefix}} | {{scope.row.totalCodeBatchStartNumber}}~{{scope.row.totalCodeBatchStartNumber}}({{scope.row.codeBatchCodeNumber}}) </template>
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchEnableNumber,codeBatchStopNumber"
                                label="启用/停用量"
                                align="center"
                                min-width="10%">
                            <template slot-scope="scope">
                                <span style="color: #008000">
                                    {{scope.row.codeBatchEnableNumber}}
                                </span>
                                /
                                <span style="color: #FF0000">
                                    {{scope.row.codeBatchStopNumber}}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchEnable"
                                min-width="10%"
                                align="center"
                                label="批次是否启用">
                            <template slot-scope="scope">
                                <div>
                                    <i class="el-icon-success" :style="{'color': (scope.row.codeBatchEnable=='1'? '#67c23A':'#606266')}" ></i>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchUpdatetime"
                                :formatter="formatCodeBatchDate"
                                min-width="15%"
                                align="center"
                                label="时间">
                        </el-table-column>
                        <el-table-column
                                prop="codeBatchEnable"
                                min-width="10%"
                                align="center"
                                label="操作">
                            <template slot-scope="scope" >
                                <div v-if=" '1' == scope.row.codeBatchEnable ">
                                    <el-button @click="unableCodeBatch(scope.row)" style="padding: 3px" size="mini" type="info">停用</el-button>
                                    <el-button @click="deleteCodeBatch(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                                </div>
                                <div v-else-if=" '0' == scope.row.codeBatchEnable ">
                                    <el-button @click="enableCodeBatch(scope.row)" style="padding: 3px" size="mini" type="success">启用</el-button>
                                    <el-button @click="deleteCodeBatch(scope.row)" style="padding: 3px" size="mini" type="danger">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div style="display: flex;justify-content: center;">
                        <el-pagination
                                background
                                @current-change="currentBatchChange"
                                @size-change="sizeBatchChange"
                                :page-size="sizeBatch"
                                :page-sizes="[5,10,20,30,50,100]"
                                layout="sizes, prev, pager, next, jumper, ->, total, slot"
                                :total="totalBatch">
                        </el-pagination>
                    </div>
                </el-form>
            </div>
            <span slot="footer" style="display: flex;justify-content: center">
                <el-button type="primary" @click="dialogCodeBatchVisible = false">完 成</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { validateAllNumber } from "../../utils/validate";
    const validateNumber = (rule, value, callback) => {
        if (!value) {
            return callback(new Error("请填写码量"));
        } else {
            const reg = /^\d$/
            if (validateAllNumber(value)) {
                callback();
            } else {
                return callback(new Error('码量只能为数字'))
            }
        }
    };
    export default {
        name: "QRMGenerate",
        data() {
            return {
                searchValue: {
                    generateCodeDate: null,
                    generateCodeId: null,
                    generateCodeMessage: null
                },
                intervalId: null,
                title: '',
                generates: [],
                codeBatchs: [],
                loading: false,
                popVisible: false,
                popVisible2: false,
                dialogVisible: false,
                total: 0,
                page: 1,
                size: 10,
                totalBatch: 0,
                pageBatch: 1,
                sizeBatch: 5,
                nations: [],
                joblevels: [],
                politicsstatus: [],
                positions: [],
                action: '',
                hideUpload: false, // 控制选择框是否显示的开关
                fileList: [],
                dialogImageUrl: '',
                dialogVisible: false,
                templateOptions: [],
                optionValue: '',
                dialogCodeBatchVisible: false,
                dialogGenerateVisible: false,
                generate: {
                    generateCodeMessage: "",
                    scanTemplateId: "",
                    generateCodeType: 0,
                    codeBatchIds: []
                },
                codeBatch: {
                    enableCodeNumber: "0",
                    codeBatchCodeNumber: '',
                    codeBatchPrefix: '',
                    codeBatchCodeLength: 6,
                    codeBatchStartNumber: 1
                },
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                rules: {
                    name: [{required: true, message: '请输入模板名称', trigger: 'blur'}],
                    type: [{required: true, message: '请选择模板类型', trigger: 'blur'}]
                },
                rulesBatch: {
                    codeBatchCodeNumber: [{required: true, validator: validateNumber, trigger: 'blur'}]
                },
                rulesGenerate: {
                    scanTemplateId: [{required: true, message: '请选择模板', trigger: 'blur'}],
                    generateCodeType: [{required: true, message: '请选择方式', trigger: 'blur'}],
                },
            }
        },
        mounted() {
            this.initGenerates();
        },
        watch:{
            total(){
                if(this.total==(this.page-1)*this.size && this.total!=0){
                    this.page-=1;
                    this.initGenerates();//获取列表数据
                }
            },
            totalBatch(){
                if(this.totalBatch==(this.pageBatch-1)*this.sizeBatch && this.totalBatch!=0){
                    this.pageBatch-=1;
                    this.initCodeBatchs();//获取列表数据
                }
            }
        },
        methods: {
            formatGenerateDate(row, column) {
                // 获取单元格数据
                let time = row.generateCodeUpdatetime;
                if(time == null) {
                    return '';
                }
                const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                let date = new Date(time.replace(pattern, '$1-$2-$3 $4:$5:$6'));
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                return Y+M+D+h+m+s;
            },
            formatCodeBatchDate(row, column) {
                // 获取单元格数据
                let time = row.codeBatchUpdatetime;
                if(time == null) {
                    return '';
                }
                const pattern = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
                let date = new Date(time.replace(pattern, '$1-$2-$3 $4:$5:$6'));
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
                var D = (date.getDate() < 10 ? '0'+date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0'+date.getSeconds() : date.getSeconds());
                return Y+M+D+h+m+s;
            },
            handleChange (file, fileList) {
                this.hideUpload = fileList.length > 0
            },
            handleRemove (file, fileList) { // 防止出场动画未结束，选择框提前出现
                setTimeout(() => {
                    this.hideUpload = fileList.length > 0
                }, 520)
            },
            handlePictureCardPreview (file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            },
            searvhViewHandleNodeClick(data) {
                this.inputDepName = data.name;
                this.searchValue.departmentId = data.id;
                this.popVisible2 = !this.popVisible2
            },
            goProductUnite() {
                this.$router.push('/qrm/qrmproductunite');
            },
            showQRGenerateView() {
                this.title = '批量生成二维码';
                this.emptyGenerate();
                this.getTemplates();
                this.initUnusedCodeBatchs();
                this.dialogGenerateVisible = true;
            }, showCodeBatchView() {
                this.title = '码批次管理';
                this.emptyCodeBatch();
                this.initCodeBatchs();
                this.dialogCodeBatchVisible = true;
            },
            deleteGenerateCode(data) {
                this.$confirm('此操作将永久删除二维码，且码量不可恢复, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/qrm/generate/delete?generateCodeId=", data).then(resp => {
                        if (resp) {
                            this.initGenerates();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            enableCodeBatch(data) {
                this.postRequest("/qrm/codebatch/enableCodeBatch", data).then(resp => {
                    if (resp) {
                        this.initCodeBatchs();
                    }
                })
            },
            unableCodeBatch(data) {
                this.postRequest("/qrm/codebatch/unableCodeBatch", data).then(resp => {
                    if (resp) {
                        this.initCodeBatchs();
                    }
                })
            },
            deleteCodeBatch(data) {
                this.$confirm('此操作将永久删除批次，且码量不可恢复, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postRequest("/qrm/codebatch/delete", data).then(resp => {
                        if (resp) {
                            this.initCodeBatchs();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            doAddCodeBatch() {
                this.$refs['codeBatchForm'].validate(valid => {
                    if (valid) {
                        this.postRequest("/qrm/codebatch/add", this.codeBatch).then(resp => {
                            if (resp) {
                                this.initCodeBatchs();
                                this.emptyCodeBatch();
                            }
                        })
                    }
                });
            },
            doAddGenerate() {
                var _this = this;
                this.$confirm('是否确定将这些批次进行生码?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.generate.codeBatchIds = _this.$refs.generateTable.selection;
                    if (!_this.generate.codeBatchIds || _this.generate.codeBatchIds.length < 1) {
                        _this.$message.error("请选择批次！");
                        return;
                    }
                    _this.$refs['generateForm'].validate(valid => {
                        if (valid) {
                            _this.postRequest("/qrm/generate/add", _this.generate).then(resp => {
                                if (resp) {
                                    _this.initUnusedCodeBatchs();
                                    _this.emptyGenerate();
                                    _this.dialogGenerateVisible = false;
                                    _this.initGenerates();
                                }
                            })
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消生码'
                    });
                });
            },
            regenerate(data) {
                var _this = this;
                this.$confirm('是否重新生成二维码?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    _this.postRequest("/qrm/generate/regenerate", data).then(resp => {
                        if (resp) {
                            _this.initGenerates();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            handleNodeClick(data) {
                this.inputDepName = data.name;
                this.generate.departmentId = data.id;
                this.popVisible = !this.popVisible
            },
            showDepView() {
                this.popVisible = !this.popVisible
            },
            showDepView2() {
                this.popVisible2 = !this.popVisible2
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initEmps();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initEmps('advanced');
            },
            sizeBatchChange(currentSize) {
                this.sizeBatch = currentSize;
                this.initCodeBatchs();
            },
            currentBatchChange(currentPage) {
                this.pageBatch = currentPage;
                this.initCodeBatchs();
            },
            sizeUnusedBatchChange(currentSize) {
                this.sizeBatch = currentSize;
                this.initUnusedCodeBatchs();
            },
            currentUnusedBatchChange(currentPage) {
                this.pageBatch = currentPage;
                this.initUnusedCodeBatchs();
            },
            initGenerates() {
                this.loading = true;
                let url = '/qrm/generate/listByPage?page=' + this.page + '&size=' + this.size;
                if (this.searchValue.generateCodeDate) {
                    url += '&generateCodeDate=' + this.searchValue.generateCodeDate;
                }
                if (this.searchValue.generateCodeId) {
                    url += '&generateCodeId=' + this.searchValue.generateCodeId;
                }
                if (this.searchValue.generateCodeMessage) {
                    url += '&generateCodeMessage=' + this.searchValue.generateCodeMessage;
                }
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.generates = resp.data;
                        this.total = resp.total;
                    }
                });
            },
            initCodeBatchs() {
                this.loading = true;
                this.getRequest('/qrm/codebatch/getUserCode').then(resp => {
                    if (resp) {
                        this.codeBatch.enableCodeNumber = resp.obj.usableCode;
                    }
                });
                let url = '/qrm/codebatch/listByPage?page=' + this.pageBatch + '&size=' + this.sizeBatch;
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.codeBatchs = resp.data;
                        this.totalBatch = resp.total;
                    }
                });
            },
            initUnusedCodeBatchs() {
                this.loading = true;
                let url = '/qrm/codebatch/listByPage?page=' + this.pageBatch + '&size=' + this.sizeBatch + '&unused=1';
                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.codeBatchs = resp.data;
                        this.totalBatch = resp.total;
                    }
                });
            },
            emptyGenerate() {
                this.generate = {
                    generateCodeMessage: "",
                    scanTemplateId: "",
                    generateCodeType: 0,
                    codeBatchIds: []
                };
            },
            emptyCodeBatch() {
                this.codeBatch = {
                    enableCodeNumber: "0",
                    codeBatchCodeNumber: '',
                    codeBatchPrefix: '',
                    codeBatchCodeLength: 6,
                    codeBatchStartNumber: 1
                };
            },
            emptyGenerate() {
                this.generate = {
                    name: "",
                    type: "0",
                    scanTemplateId: ''
                };
            },
            getTemplates() {
                this.loading = true;
                this.getRequest('/qrm/template/listUsable').then(resp => {
                    if (resp) {
                        this.templateOptions = resp.data;
                    }
                });
            },
            dataRefreh() {
                // 计时器正在进行中，退出函数
                if (this.intervalId != null) {
                    return;
                }
                // 计时器为空，操作
                this.intervalId = setInterval(() => {
                    console.log("刷新" + new Date());
                    this.initGenerates(); //加载数据函数
                }, 5000);
            },
            // 停止定时器
            clear() {
                clearInterval(this.intervalId); //清除计时器
                this.intervalId = null; //设置为null
            },
            downloadFile(generateCodeId){
                window.open("/qrtracing-front/qrm/generate/download?generateCodeId=" + generateCodeId, "_blank");
            }
        },
        created(){
            this.dataRefreh();
        },
        destroyed(){
            // 在页面销毁后，清除计时器
            this.clear();
        }
    }
</script>

<style>
    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .8s ease;
    }

    .slide-fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .generateBottom {
        padding: 10px;
        background-color: #FFFFE0;
        box-sizing: border-box;
    }

    .generateType{
        margin-top: 8px;
    }

    .generateUpload{
        display: flex;
        display: -webkit-flex;
        align-items:center;
        justify-content:center
    }

    .hide .el-upload--picture-card {
        display: none;
    }

</style>